import _ from 'lodash';
import {
  DEFAULT_STATE_VALUE, DEFAULT_K_URL, DEFAULT_J_URL, DEFAULT_Z_URL, DEFAULT_KO_URL, DEFAULT_PPL_URL, DEFAULT_ZO_URL 
} from './constants';
import {sku2array} from './logic/sku-ver3.js';
import {get_default_sku, get_default_sku2} from './reducers/utils';

// only this file exports two functions, which are the 'bridge' between the URL and app state:

// mapLocationToState takes location object and app state,
//   and returns new app state with location params merged into it

// mapStateToLocation takes app state and location,
//   and returns new location updated from app state

// functions necessary for parsing the URL parameters (eg. dates, numbers) can be implemented in here,
// or if more complicated, can be specified more rigidly somewhere else and called here

window.history.scrollRestoration = 'manual';

export function mapLocationToState(state, location) {
  switch(location.pathname) {
    case "/":
      let stateFromLocation = location.query;

      if (window.currentEnv === 'www' && stateFromLocation['hc'] === '0' && stateFromLocation['hs'] === '0' && stateFromLocation['hu'] === '0'){
        if (window.currentSite === 'kay') {
          window.location.href = DEFAULT_K_URL;
        }
        else if (window.currentSite === 'jared') {
          window.location.href = DEFAULT_J_URL;
        }
        else if (window.currentSite === 'zales') {
          window.location.href = DEFAULT_Z_URL;
        }
        else if (window.currentSite === 'zalesoutlet') {
          window.location.href = DEFAULT_ZO_URL;
        }
        else if (window.currentSite === 'kayoutlet') {
          window.location.href = DEFAULT_KO_URL;
        }
        else if (window.currentSite === 'peoplesjewellers') {
          window.location.href = DEFAULT_PPL_URL;
        }
        else {
          window.location.href = DEFAULT_Z_URL;
        }
      }

      state.loading = 'new'
      let new_sku = get_default_sku2()
   //   console.log('realinit',stateFromLocation.zalessku)
      if (stateFromLocation === undefined || ( stateFromLocation['zalessku'] === ''
        && stateFromLocation['sku'] === get_default_sku2() && stateFromLocation['cfg'] === DEFAULT_STATE_VALUE)) {
         stateFromLocation['initial'] = 'yes';
        stateFromLocation['initial-qsku'] = '' 
      }
      else {
        stateFromLocation['initial'] = '';
        stateFromLocation['initial-qsku'] = stateFromLocation['zalessku']
      }
      if (stateFromLocation !== undefined) {
        if (!['true','false'].includes(stateFromLocation['isposterminal']))
          stateFromLocation['isposterminal'] = 'false';
        let new_sku2 = decodeURIComponent(stateFromLocation['sku'])

        if (new_sku2 === get_default_sku())
          new_sku2 = get_default_sku2()

        state.initialSku = new_sku2
        if (new_sku2 !== undefined && new_sku2 !== '') 
          new_sku = new_sku2
       
       
        let allcs = ['cross1','cross2','cross3']
        for (let i in allcs) {
          stateFromLocation[allcs[i]] = parseInt(stateFromLocation[allcs[i]], 10)
          //state[csind[i]] = parseInt(allcs[i], 10) //stateFromLocation[allcs[i]]
        }
      }
      else {
        stateFromLocation = {'dct':'','isposterminal':'false','cross1':0,'cross2':0,'cross3':0} 
      }
      
      var zskulist={
        "20356973":"4FWZJ6FV",
        "20356974":"4J4B5P7RC",
        "20356975":"4QJXAKVXS",
        "20356976":"4WZJFFJH4",
        "20356977":"43HLYUPL",
        "20356978":"4BP18I3CL",
        "20356979":"4CDLTZ18G",
        "20356980":"4CZ6GH2CQ",
        "20356981":"4DNP2TFBL",
        "20356982":"4EBANHTZQ",
        "20356983":"4FLEVGSJ1",
        "20356984":"4F8YIULPV",
        "20356985":"4GVI5CKLL",
        "20356986":"4J4B5P7QM",
        "20356987":"4KQVQ761C",
        "20356988":"4LEGDO5VW",
        "20356989":"4MOKMMUPW",
        "20356990":"4NB474NKW",
        "20356991":"4NYOTMZLM",
        "20356992":"4OL9GCTKH",
        "20356993":"4QJXAKVW3",
        "20356994":"4Q7HWZQ88",
        "20356995":"4RT2IJS93",
        "20356996":"4S46QIQLX",
        "20356997":"4TRQCZPWS",
        "20356998":"4UFAYHORS",
        "20356999":"4U2UKXSVD",
        "20357000":"4WZJFFJHE",
        "20357001":"4XM31UADJ",
        "20357002":"4YANNEIUJ",
        "20357003":"4YW79VGIO",
        "20356289":"4FWZJ5LL",
        "20360771":"43H6G2FQ",
        "20360813":"43HLYUAV",
        "20360814":"43IHCJYV",
        "20360815":"4BP18I36L",
        "20360816":"4BP18I3R1",
        "20360817":"4BP23VSG1",
        "20360818":"4CDLTZ2M1",
        "20360819":"4CDLTZ6QL",
        "20360820":"4CDME9IJ1",
        "20360821":"4CDME9IX1",
        "20360822":"4CZ61QHTQ",
        "20360823":"4DNP2Y2T6",
        "20360824":"4DNQM8GB1",
        "20360825":"4EBA8QBA6",
        "20360826":"4F81521A6",
        "20360827":"4F81KTJLL",
        "20360828":"4FLGXFD7B",
        "20360829":"4FWZJ51L",
        "20360830":"4FXKSMBV",
        "20360831":"4FXUWTV1",
        "20360832":"4GVK6J93B",
        "20360833":"4J4B5OMNR",
        "20360834":"4J4CNPXYW",
        "20360835":"4J4CWPTRR",
        "20360836":"4KQWI6V87",
        "20360837":"4LEGVOUWR",
        "20360838":"4MOK5HCGM",
        "20360839":"4MOKLU892",
        "20360840":"4NB4746IH",
        "20360841":"4NB5P43UR",
        "20360842":"4NB5Y5N6M",
        "20360843":"4NYOTLL2C",
        "20360844":"4NYPCKN57",
        "20360845":"4NYPCL2QH",
        "20360846":"4OL9G3QJH",
        "20360847":"4Q7HWZ9R3",
        "20360848":"4QJXAJBFX",
        "20360849":"4RT3AJFWD",
        "20360850":"4S47IIC88",
        "20360851":"4TRQCYCBX",
        "20360852":"4U2U3YEHD",
        "20360853":"4U2VCXEAX",

        "20508505":"4HI4L7KLL",
        "20505138":"4HI3QVR9B",
        "20505137":"4O9S3K3GM",
        "20508504":"4O9S3K6QC"
        
        }

      var dict1={
      //  'Kringqsku':'46BBLQZV',
        'Kringqsku': '4BM8IYHT6',//'4BM8IYHFV',
      'Knecklaceqsku':'4J65UATGR',
      'Kearringsqsku':'4QG4KZ973',
      'Kbraceletqsku':'4W3C4Y6MT'}

      var dict2={
      //'Kringqsku':'4ZNWHIJG',
      'Kringqsku':'4BM8IYHT6',//'4BM8IYHFV',
      'Knecklaceqsku':'4J65UATGR',
      'Kearringsqsku':'4QG4KZ973',
      'Kbraceletqsku':'4W3C4Y6MT',
      //'Jringqsku':'4WT7WVSQ',
      'Jringqsku': '4BKETEU4G', //'4BKETEUO6',
      
      'Jnecklaceqsku':'4JXOQLX9M',
      'Jearringsqsku':'4QEAVGNHD',
      'Jbraceletqsku':'4WTV1BBFO'}

      if (stateFromLocation.zalessku !== '') {
        var zsku = new_sku
        if (window.currentSite === 'kayoutlet' && stateFromLocation['zalessku'] in dict1)
          zsku = dict1[stateFromLocation['zalessku']]
        else if (stateFromLocation['zalessku'] in dict2)
          zsku = dict2[stateFromLocation['zalessku']]
        else if (stateFromLocation['zalessku'] in zskulist)
          zsku = zskulist[stateFromLocation['zalessku']]
        else if (['20357071', 'Kfashionqsku', 'Jfashionqsku', 'Kfashionqsku'].includes(stateFromLocation['zalessku'])) {
          //zsku = get_default_sku()
          //stateFromLocation['initial'] = 'yes';
          //stateFromLocation['default'] = '1';
          zsku = get_default_sku2()
        }
        else {
          zsku = stateFromLocation['zalessku']
        }
        new_sku = zsku
        state.initialSku = new_sku
      }
        if (stateFromLocation['zalessku'] === '' && stateFromLocation['sku'] === '') {
          zsku = get_default_sku2()
          stateFromLocation['initial'] = '';
          new_sku = zsku
        //  zsku=''
        //  new_sku=''
        }
        //new_sku=''
    //    console.log('loc',new_sku,'zsku=',zsku,'statezalessku=',stateFromLocation['zalessku'] , 'statesku=',stateFromLocation['sku'])
        stateFromLocation['sku'] = new_sku
        stateFromLocation['initzalessku'] = stateFromLocation['zalessku']
        stateFromLocation['zalessku'] = ''
        if (new_sku !==''){
        let refParam = sku2array(new_sku) 
        var list_extra = []
        for (let i1 in list_extra) {
          refParam[list_extra[i1]] = state[list_extra[i1]]
        }
        for (let i in refParam) {
          stateFromLocation[i] = refParam[i]
        }
      }
      return _.merge({}, state, stateFromLocation);
    default:
      return state;
  }
}


export const paramSetup = {
  global: {
    action: {stateKey: 'action',  options: {shouldPush: true},initialState: 'redirect'},
    hs: {stateKey: 'hs',  options: {shouldPush: true},initialState: DEFAULT_STATE_VALUE},
    hc: {stateKey: 'hc',  options: {shouldPush: true},initialState: DEFAULT_STATE_VALUE},
    hu: {stateKey: 'hu',  options: {shouldPush: true},initialState: DEFAULT_STATE_VALUE},
    he: {stateKey: 'he',  options: {shouldPush: true},initialState: DEFAULT_STATE_VALUE},
    sku: {stateKey: 'sku',  options: {shouldPush: true},initialState: get_default_sku()},
    cfg: {stateKey: 'cfg',  options: {shouldPush: true},initialState: DEFAULT_STATE_VALUE},
    active_view: {stateKey: 'active_view',  options: {shouldPush: true},initialState: 1},
    cross1: {stateKey: 'cross1',  options: {shouldPush: true},initialState: 0},
    cross2: {stateKey: 'cross2',  options: {shouldPush: true},initialState: 0},
    cross3: {stateKey: 'cross3',  options: {shouldPush: true},initialState: 0},
    rs2: {stateKey: 'rs2',  options: {shouldPush: true},initialState: '0'},
    bl2: {stateKey: 'bl2',  options: {shouldPush: true},initialState: '0'},
    zalessku: {stateKey: 'zalessku',  options: {shouldPush: true},initialState: ''},
    initial: {stateKey: 'initial',  options: {shouldPush: true},initialState: ''},
    isposterminal: {stateKey: 'isposterminal',  options: {shouldPush: true},initialState: 'false'}    ,
    icid: {stateKey: 'icid',  options: {shouldPush: true},initialState: ''},
    cid: {stateKey: 'cid',  options: {shouldPush: true},initialState: ''},
    esaselected: {stateKey: 'esaselected',  options: {shouldPush: true},initialState: false}
  
  }
};


// WEBPACK FOOTER //
// ./src/location.js